import { useState } from "react";
import {ChatWindow} from "./ChatWindow";
import "./aiAssistant.css";
import { useTranslation } from "react-i18next";

export default function AiAssistant() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <>
            {open && <ChatWindow onClose={() => setOpen(false)} />}

            <button
                className="ai-fab"
                onClick={() => setOpen(!open)}
                title={t("AI.TITLE")}
            >
                <svg
                    viewBox="0 0 512 512"
                    width="26"
                    height="26"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ display: "block" }}
                >
                    <g fill="none" stroke="white" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M256 80 L300 200 L432 256 L300 312 L256 432 L212 312 L80 256 L212 200 Z" />
                    </g>
                </svg>
            </button>
        </>
    );
}
